import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import {
  VerificationBadge,
  type VerificationStatus,
} from "~/components/common/VerificationBadge";

type Props = {
  id: string;
  name: string | null;
  commonName: string | null;
  description: string | null;
  logoUrl: string | null;
  verification: VerificationStatus;
};

const verificationLabelKey: Record<VerificationStatus, string> = {
  verified: "Verification.verified",
  pending: "Verification.pending",
  unverified: "Verification.unverified",
};

export const MerchantCard = ({
  id,
  name,
  commonName,
  description,
  logoUrl,
  verification,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Link
      to={`/merchants/${id}`}
      className="flex flex-col rounded-xl border border-border-shell/60 dark:border-transparent bg-surface-blank p-6 shadow-simple transition hover:shadow-content"
    >
      <div className="flex items-start gap-4">
        {logoUrl?.startsWith("http") ? (
          <img
            src={logoUrl}
            alt=""
            className="h-12 w-12 shrink-0 rounded-lg bg-surface-elevated object-cover p-1"
          />
        ) : (
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-raytio-viola/15 font-heading text-base font-bold text-raytio-viola-text">
            {Array.from(name ?? "?")[0]}
          </div>
        )}
        <div className="min-w-0 flex-1">
          <h3 className="truncate font-heading font-semibold text-text-full">
            {name ?? t("MerchantCard.unnamed")}
          </h3>
          {commonName && (
            <p className="truncate text-sm text-text-light">{commonName}</p>
          )}
          <div className="mt-2">
            <VerificationBadge
              status={verification}
              label={t(verificationLabelKey[verification])}
            />
          </div>
        </div>
      </div>

      {description && (
        <p className="mt-4 line-clamp-2 flex-1 text-sm text-text-light">
          {description}
        </p>
      )}
    </Link>
  );
};
